var map = {
	"./chiang-mai.jpg": "aaad",
	"./chiang-mai/cover.jpg": "4ca2",
	"./chiang-mai/thumbnail-cover.jpg": "153d",
	"./koh-samui-resort.jpg": "a669",
	"./koh-samui-resort/cover.jpg": "c700",
	"./koh-samui-resort/thumbnail-cover.jpg": "2309",
	"./legian-bali.jpg": "4d24",
	"./legian-bali/cover.jpg": "9ad5",
	"./legian-bali/thumbnail-cover.jpg": "32af",
	"./phuket.jpg": "fd2e",
	"./phuket/cover.jpg": "648f",
	"./phuket/thumbnail-cover.jpg": "ab5b",
	"./riverside-bangkok.jpg": "1d44",
	"./riverside-bangkok/cover.jpg": "d6e6",
	"./riverside-bangkok/thumbnail-cover.jpg": "9d78",
	"./seminyak-bali.jpg": "88c2",
	"./seminyak-bali/cover.jpg": "9a98",
	"./seminyak-bali/thumbnail-cover.jpg": "001e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "582d";